import React from 'react';
import withWrapper from '../withWrapper';
export default withWrapper('Cutting', function (props) {
  return React.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("rect", {
    width: "48",
    height: "48",
    fill: "white",
    "fill-opacity": "0.01"
  }), React.createElement("path", {
    d: "M9 10V44H39V10H9Z",
    fill: "none",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), React.createElement("path", {
    d: "M20 20V33",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), React.createElement("path", {
    d: "M28 20V33",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), React.createElement("path", {
    d: "M4 10H44",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), React.createElement("path", {
    d: "M16 10L19.289 4H28.7771L32 10H16Z",
    fill: "none",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }));
});